// @view/authentication/EmailValidationBodyIdle.view.tsx

import React from "react";
import type { EmailValidationViewProps } from "@ps-bridge/contracts/emailValidation";
import EmptyView from "@view/EmptyView";

type EmailValidationBodyIdleContractProps = Pick<EmailValidationViewProps, never>;

const EmailValidationBodyIdleView: React.FC<EmailValidationBodyIdleContractProps> = () => {
  return <EmptyView />;
};

export default EmailValidationBodyIdleView;
